import React, { createRef } from "react";
import BarPlot from "./BarPlot";
import { useScreenshot, createFileName } from "use-react-screenshot";

import "./BarPlot.css";

export default function BarPlots({ barPlots }) {
  return (
    <div className="barPlotsBox">
      {
        <div className="barPlotBox">
          <div className="barPlotBox__title">{barPlots[0].Attribute_group}</div>
          {barPlots.map((barPlot) => (
            <BarPlot barPlot={barPlot} key={barPlot.Attribute} />
          ))}
        </div>
      }
    </div>
  );
}
